import React, { useState } from 'react';

import { Button, ButtonGroup, Col, Row, ToggleButton } from 'react-bootstrap';

import edit from '../../../../assets/svg/edit.svg';
import ColoredMarker from '../../../../common/components/ColoredMarker';
import { RequiredInput } from '../../../../common/components/FormError';

const OrderPreviewInfos = (props: any) => {
  const [editMode, setEditMode] = useState(false);

  //preview change
  const handleChangeInfos = (infoType: string, value: any) => {
    //Fetch from property
    if (['lessorName', 'batchNumber', 'digicode'].includes(infoType)) {
      const copyOf = props.preview.property;
      copyOf[infoType] = value;
      infoType = 'property';
      props.setPreview({ ...props.preview, [infoType]: copyOf });
    } else if (['street', 'zip', 'streetSupplement', 'residenceName', 'city'].includes(infoType)) {
      const copyOf = props.preview.property.address;
      copyOf[infoType] = value;
      infoType = 'property.address';
      props.setPreview({ ...props.preview, [infoType]: copyOf });
    } else if (
      ['building', 'floor', 'stairs', 'door', 'cellarNum', 'boxNum', 'parkingExtNum', 'parkingIntNum'].includes(
        infoType
      )
    ) {
      const copyOf = props.preview.property.addressDetails;
      copyOf[infoType] = value;
      infoType = 'property.addressDetails';
      props.setPreview({ ...props.preview, [infoType]: copyOf });
    } else {
      props.setPreview({ ...props.preview, [infoType]: value });
    }
  };

  const handleChanges = () => {
    //TODO implement
    setEditMode(false);
  };

  return (
    <>
      <div className="d-flex flex-row justify-content-between m-2 align-middle align-items-center gap-4 flex-wrap ">
        <div className="d-flex flex-row justify-content-start gap-2 align-middle align-items-center ">
          {props.preview.category === 'entry' && <ColoredMarker color="#11BFA4">EDL Entrée</ColoredMarker>}
          {props.preview.category === 'exit' && <ColoredMarker color="#ECB900">EDL Sortie</ColoredMarker>}
          <p className="popoverTextSecondary fw-bold align-middle align-items-center mt-3">
            N° {props.preview.property.uid}
          </p>
        </div>
        {editMode ? (
          <Button variant="primary" role="button" onClick={() => handleChanges()}>
            Enregistrer les modifications
          </Button>
        ) : (
          <button className="btn btn-actions btn-edit-order cursor-pointer" onClick={() => setEditMode(true)}>
            <img src={edit} alt="edit" style={{ width: '12px', height: '12px' }} />
          </button>
        )}
      </div>
      <Row>
        <Col md={6} lg={3} className="d-flex justify-content-start flex-column mt-2">
          <label className="w-100 add-prop-label ms-2">Nom du bailleur :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            min={0}
            name="lessor"
            value={props.preview.property.lessorName}
            onChange={(e) => handleChangeInfos('lessorName', e.target.value)}
          />
        </Col>
        <Col md={6} lg={3} className="d-flex justify-content-start flex-column mt-2">
          <label className="w-100 add-prop-label ms-2">N° de lot de gestion :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            min={0}
            name="ref"
            value={props.preview.property.batchNumber}
            onChange={(e) => handleChangeInfos('batchNumber', e.target.value)}
          />
        </Col>
        <Col md={6} lg={4} className="d-flex justify-content-start flex-column mt-2">
          <label className="w-100 add-prop-label ms-2">S’agit-il d’une copropriété ? </label>
          <ButtonGroup className="btn-group-prop w-100">
            <ToggleButton
              disabled={!editMode}
              className="btn-add-prop ms-1"
              checked={props.preview.isCondominium === true}
              type="radio"
              value="true"
              onClick={() => handleChangeInfos('isCondominium', true)}
            >
              Oui
            </ToggleButton>
            <ToggleButton
              disabled={!editMode}
              className="btn-add-prop ms-1"
              checked={props.preview.isCondominium === false}
              type="radio"
              value="false"
              onClick={() => handleChangeInfos('isCondominium', false)}
            >
              Non
            </ToggleButton>
          </ButtonGroup>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col className="d-flex flex-column justify-content-between" xs={12} md={8}>
          <label className="w-100 add-prop-label ms-lg-2">
            Adresse du bien : <RequiredInput />
          </label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="address"
            value={props.preview.property.address.street}
            onChange={(e) => handleChangeInfos('street', e.target.value)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between" xs={12} md={4}>
          <label className="w-100 add-prop-label ms-lg-2">Complément d'adresse :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="addressSupplement"
            value={props.preview.property.address.streetSupplement}
            onChange={(e) => handleChangeInfos('streetSupplement', e.target.value)}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-2">
            Code postal : <RequiredInput />
          </label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="zip"
            value={props.preview.property.address.zip}
            onChange={(e) => handleChangeInfos('zip', e.target.value)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-2">
            Ville : <RequiredInput />
          </label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="city"
            value={props.preview.property.address.city}
            onChange={(e) => handleChangeInfos('city', e.target.value)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-lg-2">Nom de la résidence :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="residenceName"
            value={props.preview.property.address.residenceName}
            onChange={(e) => handleChangeInfos('residenceName', e.target.value)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-lg-2">Digicode :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="digicode"
            value={props.preview.property.digicode}
            onChange={(e) => handleChangeInfos('digicode', e.target.value)}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-2">Bâtiment :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="building"
            value={props.preview.property.addressDetails.building}
            onChange={(e) => handleChangeInfos('building', e.target.value)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-2">
            Étage : <RequiredInput />
          </label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="floor"
            value={props.preview.property.addressDetails.floor}
            onChange={(e) => handleChangeInfos('floor', e.target.value)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-2">Escalier :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="stairs"
            value={props.preview.property.addressDetails.stairs}
            onChange={(e) => handleChangeInfos('stairs', e.target.value)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-2">Porte :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="door"
            value={props.preview.property.addressDetails.door}
            onChange={(e) => handleChangeInfos('door', e.target.value)}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-2">N° de cave :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="cellarNum"
            value={props.preview.property.addressDetails.cellarNum}
            onChange={(e) => handleChangeInfos('cellarNum', e.target.value)}
            placeholder="Si absence indiquez SO"
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-2">N° de box garage :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="boxNum"
            value={props.preview.property.addressDetails.boxNum}
            onChange={(e) => handleChangeInfos('boxNum', e.target.value)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-2">N° de parking éxterieur :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="parkingExtNum"
            value={props.preview.property.addressDetails.parkingExtNum}
            onChange={(e) => handleChangeInfos('parkingExtNum', e.target.value)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between" xs={12} md={3}>
          <label className="w-100 add-prop-label ms-2">N° de parking intérieur :</label>
          <input
            disabled={!editMode}
            className="w-100 add-prop-input"
            type="text"
            name="parkingIntNum"
            value={props.preview.property.addressDetails.parkingIntNum}
            onChange={(e) => handleChangeInfos('parkingIntNum', e.target.value)}
          />
        </Col>
      </Row>
    </>
  );
};

export default OrderPreviewInfos;
